import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { MenuItem, Select, FormControl, InputLabel, IconButton, Tooltip } from "@mui/material";
import { useManageCommission } from "./hooks/useManageCommission";
import { noDataComponent } from '../../../util/DataObject';
import { customStyles2 } from '../../../util/TableStyles';
import { ManageCommissionsDialogProps } from './types';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import InfoIcon from '@mui/icons-material/Info';

export const ManageCommissions = ({ item, type, open, fromTable, changeLoader, changeAlert, onClose, onConfirm }: ManageCommissionsDialogProps) => {
    const { form, isValid, columns, sellers, zPos, error, onHandleSave, onHandleGetById, onHandleChange, onHandleConfirm, onDeleteFromList } = useManageCommission(changeLoader, changeAlert, onConfirm, open);
    
    useEffect(() => {
        open && item && (fromTable ? onHandleSave(item) : onHandleGetById(item, type));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        item && (
            <Dialog onClose={onClose} open={open} style={{minWidth: 600, maxHeight: 500, visibility: zPos !== 45 ? "hidden" : "visible"}}>
                <DialogTitle>
                    <Typography variant='h2'>Administrar comisiones {type === "lead" ? "de la empresa" : "del vendedor" }</Typography>
                </DialogTitle>

                <DialogContent>
                    <InfoIcon fontSize='small' color='primary' sx={{ mr: 0.5, verticalAlign: "sub" }}/><Typography variant='small' color='primary'>Selecciona al agente y/o promotor.</Typography>
                    { sellers && <FlexGrid container spacing={2} style={{marginTop: 30}}>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel>Agentes</InputLabel>
                            <Select label={"Agentes"} value={-1} onChange={onHandleChange.bind(this, "agent", "")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                {sellers.map((i) => (
                                    i.role === "agent" && <MenuItem key={`agent-${i.uuid}`} value={i}>
                                        {i.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" fullWidth >
                            <InputLabel>Promotores</InputLabel>
                            <Select label={"Promotores"} value={-1} onChange={onHandleChange.bind(this, "promoter", "")} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2}} fullWidth variant="outlined">
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                {sellers.map((i) => (
                                    i.role === "promoter" && <MenuItem key={`promoter-${i.uuid}`} value={i}>
                                        {i.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </FlexGrid>}

                    { form && 
                        <FlexGrid item style={{fontSize: 12, marginBottom: "1rem"}}>
                            <hr /> <span style={{ color: "#3743aa"}}>A continuación selecciona el porcentaje correspondiente.</span>
                        </FlexGrid>
                    }
                    { form && 
                        <DataTable
                            columns={columns}
                            data={form.filter(i => !i.status || i.status === "enabled")}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                        />
                    }
                    { form  && form.filter(i => i.status && i.status !== "enabled").length > 0 &&
                        <FlexGrid item style={{fontSize: 12, marginBottom: "1rem", display: "grid"}}>
                            <hr /> <span style={{ color: "red"}}>Los siguientes registros están o serán dados de baja.</span>
                            {form.map((i) => (
                                    i.status && i.status !== "enabled" && <Typography key={`seller-${i.uuid}`} variant='smallTitle'>
                                        {i.commission}% - {i.seller.name}
                                        <Tooltip title={"Restaurar"}>
                                            <IconButton sx={{ px: "0 !important", ml: 2 }} onClick={() => onDeleteFromList(i.seller.uuid, i['uuid'] || null, "enabled")}>
                                                <RestartAltIcon titleAccess={`Restaurar a \nla lista`} cursor={"pointer"}/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                ))}
                        </FlexGrid>
                    }
                    { error && 
                        <FlexGrid item style={{fontSize: 12, marginBottom: "1rem"}}>
                            <hr /> <span style={{ color: "red"}}>{error}</span>
                        </FlexGrid>
                    }
                </DialogContent>

                <DialogActions>
                    <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: 10 }}>
                        <FlexGrid item>
                            <Button onClick={onClose} buttonType="secondary" size="normal">Cancelar</Button>
                        </FlexGrid>
                        <FlexGrid item>
                            <Button onClick={onHandleConfirm} disabled={isValid} size="normal" >Aceptar</Button>
                        </FlexGrid>
                    </FlexGrid>
                </DialogActions>
            </Dialog>
        )
    );
};
